// libs
import { styled } from '@nykaa/ui-components';

//components
import BaseButton from '@nykaa/ui-components/Button';

export const Container = styled.div`
  justify-content: space-between;
  display: flex;
  border-color: ${({ theme }) => theme.colors.surface20};
  ${({ theme }) => theme.borders.border150};

  padding: ${({ theme }) =>
    `${theme.spacing.spacing60} ${theme.spacing.spacing120} ${theme.spacing.spacing60} ${theme.spacing.spacing100}`};
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const Button = styled(BaseButton)<{ isApplyButton: boolean }>`
  border: ${({ theme }) => `1px solid ${theme.colors.textOutline}`};
  padding: ${({ theme }) => `${theme.spacing.spacing50} ${theme.spacing.spacing80}`};
  border-radius: ${({ theme }) => theme.spacing.spacing10};
  ${({ theme }) => theme.typography.buttonMedium};

  ${({ isApplyButton, theme }) => isApplyButton && `margin-left: ${theme.spacing.spacing40};`};
`;
